import { render, staticRenderFns } from "./PTableWidth.vue?vue&type=template&id=1175015b"
import script from "./PTableWidth.vue?vue&type=script&lang=js"
export * from "./PTableWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports